import React from "react";
import { Box, Typography } from "@mui/material";
import ActionModal from "./ActionModal";
import NoticeboardButton from "./NoticeboardButton";

type ContactSupportUpgradeDialogProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  /** What to contact support about, e.g. "To turn on Family". */
  children: React.ReactNode;
};

/** The "contact Noticeboard support" upgrade dialog. No price: that's handled in conversation. */
const ContactSupportUpgradeDialog: React.FC<ContactSupportUpgradeDialogProps> = ({
  open,
  onClose,
  title,
  children,
}) => (
  <ActionModal
    open={open}
    onClose={onClose}
    title={title}
    subtitle="Contact Noticeboard support to upgrade your subscription"
    maxWidth="sm"
    headerStyle="light"
  >
    <Box sx={{ p: 3, textAlign: "center" }}>
      <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
        {children}
      </Typography>
      <NoticeboardButton variant="primary" onClick={onClose} fullWidth>
        Close
      </NoticeboardButton>
    </Box>
  </ActionModal>
);

export default ContactSupportUpgradeDialog;
